import {call, put, takeLatest} from 'redux-saga/effects';
import {delay} from 'redux-saga';
import { showGeneralError, hideGeneralError } from '../actions/general.actions';
import {GENERIC_ERROR_MESSAGE} from "../config/messages";
import { showSpinner, hideSpinner } from '../actions/loading.actions';
import { getNotificationCategories, updateProfileNotificationSettings, getUserProfile, updateFavoriteGenres, updateUserDetails} from '../api/editprofile.api';
import { GET_NOTIFICATION_CATEGORIES, UPDATE_PROFILE_NOTIFICATION_SETTINGS, GET_USER_PROFILE, UPDATE_FAVORITE_GENRES, UPDATE_USER_DETAILS } from '../actions/types';
import { getNotificationCategoriesSucceeded, getUserProfileSucceeded } from '../actions/editprofile.actions';
import { getUserDetailsSucceeded } from '../actions/profile.actions';

function* getNotificationCategoriesSaga(action){
    try{
        yield put(showSpinner())
        const response = yield call(getNotificationCategories, action.payload)
        if (response.status){
            yield put(hideSpinner());
        }
        if (response.status === 200){
            const notificationCategories = response.data.find(obj => {
                return obj.vocabulary_id === "notification_categories"
            })

            yield put(getNotificationCategoriesSucceeded(notificationCategories))
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* updateProfileNotificationSettingsSaga(action){
    try {
        yield put(showSpinner())
        const response = yield call(updateProfileNotificationSettings, action.payload);
        if (response.status){
            yield put(hideSpinner());
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getUserProfileSaga(action){
    try {
        yield put(showSpinner())
        const response = yield call(getUserProfile, action.payload);
        if (response.status){
            yield put(hideSpinner());
        }
        if (response.status === 200){
            yield put(getUserProfileSucceeded(response.data))
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* updateFavoriteGenresSaga(action){
    try{
        yield put(showSpinner());
        const response = yield call(updateFavoriteGenres, action.payload);
        if (response.status){
            yield put(hideSpinner());
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* updateUserDetailsSaga(action){
    try{
        yield put(showSpinner());
        const response = yield call(updateUserDetails, action.payload)
        if(response.status === 200){
            yield put(hideSpinner());
            const userProfileResponse = yield call(getUserProfile, action.payload);
            if (userProfileResponse.status === 200){
                yield put(getUserDetailsSucceeded(userProfileResponse.data))
            }
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

export default function* editProfileSaga(){
    yield takeLatest(GET_NOTIFICATION_CATEGORIES, getNotificationCategoriesSaga);
    yield takeLatest(UPDATE_PROFILE_NOTIFICATION_SETTINGS, updateProfileNotificationSettingsSaga);
    yield takeLatest(GET_USER_PROFILE, getUserProfileSaga);
    yield takeLatest(UPDATE_FAVORITE_GENRES, updateFavoriteGenresSaga);
    yield takeLatest(UPDATE_USER_DETAILS, updateUserDetailsSaga);
}


// WEBPACK FOOTER //
// ./src/SHARED/sagas/editprofile.saga.js